import { computed, inject, Injectable, signal } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { RelationCheckService } from '@services/relation-check.service';

@Injectable({
  providedIn: 'root',
})
export class EnsureParentChildRelation implements CanActivate {
  private relationService = inject(RelationCheckService);
  private router = inject(Router);

  private route = signal<ActivatedRouteSnapshot | null>(null);

  private householdId = computed(() => {
    const id = this.route()?.paramMap.get('id');
    return id ? Number(id) : null;
  });
  private guestId = computed(() => {
    const id = this.route()?.paramMap.get('guestId');
    return id ? Number(id) : null;
  });

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): MaybeAsync<GuardResult> {
    this.route.set(route);

    if (!this.householdId() || !this.guestId()) {
      return this.router.createUrlTree(['/foyers']);
    }

    return this.relationService
      .checkRelation(this.guestId()!, this.householdId()!, 'guest_in_household')
      .pipe(
        map(() => true),
        catchError(() => of(this.router.createUrlTree(['/foyers'])))
      ) as Observable<GuardResult>;
  }
}
